angular.
module("dx.webapp.region").
controller("DxRegionController", function RegionController(
	$location,
	dxRegion,
	DX_URLS
) {
	"use strict";

	this.regions = dxRegion.regions;
	this.region = null;

	this.selectRegion = function selectRegion(region) {
		dxRegion.setSelected(region);

		if (region.domain === dxRegion.getCurrent().domain) {
			var returnToQueryString = "";
			var searchObject = $location.search();
			if (searchObject.return_to) {
				returnToQueryString = "?return_to=" + encodeURIComponent(searchObject.return_to);
			}

			$location.url(DX_URLS.routes.login + returnToQueryString);
		} else {
			dxRegion.redirectTo(region);
		}
	};
});
